import { getRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';

import type { Provider } from './CategoriesStore';

type ProviderResponse = { providerName: string; providerId: string };

export async function fetchActiveProviders(): Promise<Provider[]> {
  const response = await getRequest<ApiResponse<ProviderResponse[]>>('user/providers');

  return response.data.data.map(({ providerName, providerId }) => ({ id: providerId, name: providerName }));
}
